export default __webpack_public_path__ + "static/media/Listen_icon.344daaef.png";